module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43318cd6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingBar.vue
// module id = 494
// module chunks = 2